import { DocType } from "./doc-type";
var extToDocType = {
  '.docx': DocType.Doc,
  '.doc': DocType.Doc,
  '.wps': DocType.Doc,
  '.wpt': DocType.Doc,
  '.dot': DocType.Doc,
  '.dotx': DocType.Doc,
  '.docm': DocType.Doc,
  '.dotm': DocType.Doc,
  '.xls': DocType.Sheet,
  '.xlm': DocType.Sheet,
  '.xla': DocType.Sheet,
  '.xlc': DocType.Sheet,
  '.xlt': DocType.Sheet,
  '.xlw': DocType.Sheet,
  '.xlsx': DocType.Sheet,
  '.xltx': DocType.Sheet,
  '.csv': DocType.Sheet,
  '.xlsb': DocType.Sheet,
  '.xlsm': DocType.Sheet,
  '.xltm': DocType.Sheet,
  '.et': DocType.Sheet,
  '.ett': DocType.Sheet,
  '.pptx': DocType.Slide,
  '.ppt': DocType.Slide,
  '.pps': DocType.Slide,
  '.pot': DocType.Slide,
  '.potx': DocType.Slide,
  '.ppsx': DocType.Slide,
  '.dps': DocType.Slide,
  '.dpt': DocType.Slide,
  '.pptm': DocType.Slide,
  '.potm': DocType.Slide,
  '.ppsm': DocType.Slide,
  '.vsdx': DocType.FlowChart,
  '.vsd': DocType.FlowChart,
  '.pos': DocType.Mind,
  '.xmind': DocType.Mind,
  '.pdf': DocType.Pdf,
  '.md': DocType.Markdown,
  '.markdown': DocType.Markdown
};
export var getDocTypeFromExt = function getDocTypeFromExt(ext) {
  return extToDocType[ext.toLowerCase()];
};
//# sourceMappingURL=ext-to-doctype.js.map